import React, { useEffect, useRef, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

/*
 * Ventanas propias de Drive: crear carpeta, cambiar nombre y confirmar un
 * borrado definitivo.
 *
 * Antes eran `window.prompt` y `window.confirm`: los cuadros grises del
 * navegador, con los botones en inglés y sin nada de la marca. Se ven como si
 * la página hubiera fallado, y en el móvil salen pegados arriba.
 */

/** Pide un texto (nombre de carpeta, nombre de archivo). */
export function DialogoTexto({
  open,
  titulo,
  descripcion,
  etiqueta,
  valorInicial = '',
  sufijo,
  boton = 'Guardar',
  onConfirmar,
  onOpenChange,
}) {
  const [valor, setValor] = useState(valorInicial);
  const campo = useRef(null);

  // Al abrir se parte del valor que toca (renombrar trae el nombre actual)
  useEffect(() => {
    if (open) setValor(valorInicial);
  }, [open, valorInicial]);

  const confirmar = () => {
    const limpio = valor.trim();
    if (!limpio) return;
    onOpenChange(false);
    onConfirmar(limpio);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[420px]"
        data-testid="drive-dialogo-texto"
        onOpenAutoFocus={(e) => {
          e.preventDefault();
          campo.current?.focus();
          campo.current?.select();
        }}
      >
        <DialogHeader>
          <DialogTitle>{titulo}</DialogTitle>
          {descripcion ? <DialogDescription>{descripcion}</DialogDescription> : null}
        </DialogHeader>
        <div className="flex items-center gap-2">
          <Input
            ref={campo}
            value={valor}
            onChange={(e) => setValor(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') confirmar(); }}
            placeholder={etiqueta}
            aria-label={etiqueta}
            className="rounded-xl"
            data-testid="drive-dialogo-campo"
          />
          {sufijo ? (
            <span className="text-sm shrink-0" style={{ color: 'var(--text-3)' }}>{sufijo}</span>
          ) : null}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={confirmar} disabled={!valor.trim()} data-testid="drive-dialogo-confirmar">{boton}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export { DialogoConfirmar } from '../ui/confirmar';
